const Title = () => {
  return (
    <div className='overflow-hidden px-2 flex justify-center mb-4'>
      <div className='w-full'>
        <div className='flex items-center flex-shrink-0 text-black'>
          <div className='mt-3'>
            <h1 className='text-3xl md:text-4xl lg:text-5xl'>
              NPM <span className='text-blue-400'>Popularity</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Title
